import { Components } from "appworks/components/components";
import { Layers } from "appworks/graphics/layers/layers";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { FowlFlingBonusBackgroundComponent } from "components/bonus/fling/fowl-fling-bonus-background-component";
import { FlingBonusPrizeTier, FowlFlingBonusComponent } from "components/bonus/fling/fowl-fling-bonus-component";
import { FowlFlingBonusTransitionComponent } from "components/bonus/fling/fowl-fling-bonus-transition-component";
import { gameLayers } from "game-layers";
import { FowlJackpotBonusResult } from "model/results/fowl-jackpot-bonus-result";
import { FooterComponent } from "slotworks/components/footer/footer-component";

export class FowlEnterFlingBonusState extends State {
    public onEnter(): void {
        new Sequence([
            () => gameLayers.ScreenFade.setScene("black"),
            () => gameLayers.BackgroundPersistentAnimation.setScene("fling"),
            () => gameLayers.BackgroundIntermittentAnimation.setScene("fling"),
            () => gameLayers.FlingBonus.setScene("bonus"),
            () => Components.get(FowlFlingBonusBackgroundComponent).show(),
            () =>
                Contract.wrap(() => {
                    Layers.setLayerOrder("flingbonus");
                    uiFlags.set(UIFlag.BONUS, true);
                    Components.get(FooterComponent).clear();

                    Components.get(FowlFlingBonusComponent).startBonus(this.getTier());

                    Services.get(SoundService).customEvent("faf_music_start");
                }),
            () => gameLayers.ScreenFade.defaultScene(),
            () => Components.get(FowlFlingBonusTransitionComponent).playFlingIntro(),
        ]).then(() => this.complete());
    }

    protected getTier(): FlingBonusPrizeTier {
        const result = gameState.getCurrentGame().getLatestResultOfType(FowlJackpotBonusResult);
        return result.tier;
    }
}
